/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'

import TextInputWithMargin from './TextInputWithMargin';


const EmailInput = (props) => {
  return (
    <TextInputWithMargin
      type="email"
      name="email"
      {...props}
      onChange={(event) => {
        props.onChange(event.target.value);
      }}
    />
  );
}

export default EmailInput;
